import {useMemo} from "react";

export function useIsTouch() {
    return useMemo(() => window.matchMedia("(pointer: coarse)").matches, []);
}

export function useIsSmallScreen() {
    return useMemo(() => window.innerWidth < 500, []);
}